// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m-OL","largestCol":"styles_largestCol__25rQk","smallestCol":"styles_smallestCol__3yFOo"};